import React from 'react';
import { useNavigate } from 'react-router-dom';
import leftArrowNoBg from '../DietPlanSuccess/left-arrow.svg';

const PlanHeader = ({header, title, subtitle}) => {

    const navigate = useNavigate();

    return(
        <>
            <div className='plan-header'>
                <img src={leftArrowNoBg} alt="" className='diet-plan-left-arrow-specific' onClick={() => navigate(-1)} />
                <img src={header} alt="" className='w-100'  />
                {/* <div className='category-bottom-header text-center pb-4'>
                    Limited time offer of 80% off on diet plans
                </div> */}
            </div>
            <div className='plan-card'>
                <h1 className='plan-card-title mt-4 mb-3'>{title}</h1>
                <p className='plan-card-subtitle mb-4'>{subtitle}</p>
            </div>
            
        </>
    )
}

export default PlanHeader;